var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v2-card af-card",attrs:{"data-qid":"history-tab"}},[_c('ActivityFeed',{attrs:{"log":_vm.object.who_am_i + '::' + _vm.object.id,"here":_vm.object,"action-filter":"","person-filter":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }